module.exports = __webpack_public_path__ + "assets/img/article.840d66e7.svg";